import React from 'react'

function Footer() {
  return (
    <div className="footer-part">
      Thanks for watching my project. Feel free to visit my github : <a href="https://github.com/erambeau" target="_blank" rel="noreferrer">https://github.com/erambeau</a>
    </div>
  )
}

export default Footer